export const platformFontFamily = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--font-family');

export const headingLargeFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--heading-large-font-size');

export const headingMediumFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--heading-medium-font-size');
export const headingSmallFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--heading-small-font-size');
export const mediumFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--medium-font-size');
export const smallFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--small-font-size');
export const xSmallFontSize = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--xsmall-font-size');

export const colorBlackMain = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--black-main');
export const colorWhiteMain = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--white-main');
// export const colorBeigeMain = (docStyle: CSSStyleDeclaration) =>
//   docStyle.getPropertyValue('--beige-main');
export const colorGrayPale = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--gray-pale');
export const colorGrayDark = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--gray-dark');
export const colorGrayOpacity = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--gray-opacity');
export const colorGrayDarker = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--gray-darker');

export const colorPurpleDark = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--purple-dark');
export const colorPurpleText = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--purple-text');
export const colorPurpleLight = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--purple-light');

export const colorRedLight = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--red-light');
export const colorRedMain = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--red-main');
export const colorTealMain = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--teal-main');
export const colorTealLight = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--teal-light');

export const colorGreenChartDark = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-chart-dark');
export const colorGreenChartMiddle = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-color');
export const colorGreenChartLight = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-chart-light');
export const colorGreenChartPale = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-chart-pale');
export const colorGreenBorder = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-border');
export const colorGreenRadarDarkBorder = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-dark');
export const colorGreenRadarDarkFill = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-dark-fill');
export const colorGreenRadarMiddleBorder = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-middle');
export const colorGreenRadarMiddleFill = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-middle-fill');
export const colorGreenRadarLightBorder = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-light');
export const colorGreenRadarLightFill = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--green-radar-light-fill');
export const colorBlueDark = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--blue-dark');
export const colorBlueDarker = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--blue-darker');
export const colorBlueDarkest = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--blue-darkest');

export const bigPadding = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--big-padding');
export const defaultPadding = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--default-padding');
export const mediumPadding = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--medium-padding');
export const smallPadding = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--small-padding');
export const xSmallPadding = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--xsmall-padding');

export const xxxSmallBorderRadius = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--xxxsmall-border-radius');

export const topNavHeight = (docStyle: CSSStyleDeclaration) =>
  docStyle.getPropertyValue('--top-nav-height');
